import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class AircraftModelsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      name: null,
      model: null,
      motor: null,
      size: null,
      class: null,
      pilots_type: null,
      fuel_type_id: null,
      manufacturer: null,
      fuel_types_list: [],
      use_in_planning: 0,
      cost_center: 0,
      ground_consumption: 0,
      flight_consumption: 0,
      fuel_capacity: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/tipo/combustivel/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ fuel_types_list: responseJson.data });
        }
      }).then(() => {
        var url = config.get('api') + '/unidade/combustivel/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({fuel_unity_list: responseJson.data});
          }
        }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); });
    });
  }
  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      model: this.state.model,
      motor: this.state.motor,
      size: this.state.size,
      class: this.state.class,
      use_in_planning: this.state.use_in_planning,
      fuel_unity_id: this.state.fuel_unity_id,
      fuel_type_id: this.state.fuel_type_id,
      manufacturer: this.state.manufacturer,
      pilots_type: this.state.pilots_type,
      cost_center: this.state.cost_center,
      ground_consumption: this.state.ground_consumption,
      flight_consumption: this.state.flight_consumption,
      fuel_capacity: this.state.fuel_capacity,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/modelo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/aeronave/modelo/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.titulo}</h3>
      <Link to="/aeronave/modelos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.placeholder.NomeAeronave} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.Modelo}:</label>
              <input type="text" name="model" className="form-control" placeholder={this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.placeholder.ModeloAeronave}value={this.state.model} onChange={this.handleChange.bind(this, 'model')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.Classe}:</label>
              <Select
                className="form-field-name"
                name="class"
                value={this.state.class}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.placeholder.SelecioneClasse}
                onChange={this.handleSelectChange.bind(this, 'class')}
                options={[
                  {value: "Avião", label: this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.opcoesClasses.Aviao},
                  {value: "Helicóptero", label: this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.opcoesClasses.Helicoptero},
                ]}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.Porte}:</label>
              <Select
                className="form-field-name"
                name="size"
                value={this.state.size}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.placeholder.SelecionePorte}
                onChange={this.handleSelectChange.bind(this, 'size')}
                options={[
                  {value: "PP", label: this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.opcoesPorte.Pequeno},
                  {value: "MP", label: this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.opcoesPorte.Medio},
                  {value: "SMP", label: this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.opcoesPorte.SuperMedio},
                  {value: "GP", label: this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.opcoesPorte.Grande},
                ]}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.UnidadeCombustivel}:</label>
              <Select
                className="form-field-name"
                name="fuel_unity_id"
                value={this.state.fuel_unity_id}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.placeholder.SelecioneUnidadeCombustivel}
                onChange={this.handleSelectChange.bind(this, 'fuel_unity_id')}
                options={this.state.fuel_unity_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.TipoCombustivel}:</label>
              <Select
                className="form-field-name"
                name="fuel_type_id"
                value={this.state.fuel_type_id}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.placeholder.SelecioneTipoCombustivel}
                onChange={this.handleSelectChange.bind(this, 'fuel_type_id')}
                options={this.state.fuel_types_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.Motorizacao}:</label>
              <Select
                className="form-field-name"
                name="motor"
                value={this.state.motor}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.placeholder.SelecioneMotorizacao}
                onChange={this.handleSelectChange.bind(this, 'motor')}
                options={[
                  {value: "MULTI", label: this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.opcoesMotorizacao.Multimotor},
                  {value: "MONO", label: this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.opcoesMotorizacao.Monomotor},
                ]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.TipoTripulacao}:</label>
              <Select
                className="form-field-name"
                name="pilots_type"
                value={this.state.pilots_type}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.placeholder.TipoTripulacao}
                onChange={this.handleSelectChange.bind(this, 'pilots_type')}
                options={[
                  {value: "Dual pilot", label: this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.opcoesTipoTripulacao.DualPilot},
                  {value: "Single pilot", label: this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.opcoesTipoTripulacao.SinglePilot},
                ]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.Fabricante}:</label>
              <input type="text" name="manufacturer" className="form-control" placeholder={this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.placeholder.FabricanteAeronave} value={this.state.manufacturer} onChange={this.handleChange.bind(this, 'manufacturer')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.ConsumoHoraSolo}:</label>
              <input type="text" placeholder="Valor/Litro" className="form-control" name="ground_consumption" value={this.state.ground_consumption} onChange={this.handleChange.bind(this, 'ground_consumption')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.ConsumoHoraVoo}:</label>
              <input type="text" placeholder="Valor/Litro" className="form-control" name="flight_consumption" value={this.state.flight_consumption} onChange={this.handleChange.bind(this, 'flight_consumption')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.CapacidadeDeCombustível}:</label>
              <input type="text" placeholder="Valor/Litro" className="form-control" name="fuel_capacity" value={this.state.fuel_capacity} onChange={this.handleChange.bind(this, 'fuel_capacity')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ModelosAeronaves.AdicionarModelosAeronaves.formulario.botaoAdicionarModelo}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftModelsAdd;



// WEBPACK FOOTER //
// ./src/Components/AircraftModels/AircraftModelsAdd.js